import React, {useContext} from 'react';
import {TouchableOpacity, StyleSheet} from 'react-native';
import PropTypes from 'prop-types';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import {I18nContext} from 'i18n/context/I18nContext';

const VideoFullscreenButton = ({expanded, onPress, testID}) => {
  const {translate} = useContext(I18nContext);
  const handlePress = event => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    onPress();
  };

  return (
    <TouchableOpacity
      accessibilityLabel={
        expanded
          ? translate('controls.minimizeVideo')
          : translate('controls.expandVideo')
      }
      accessibilityRole="button"
      accessibilityState={{expanded}}
      activeOpacity={0.8}
      hitSlop={{top: 8, right: 8, bottom: 8, left: 8}}
      onPress={handlePress}
      style={styles.button}
      testID={testID}
    >
      <Icon
        name={expanded ? 'fullscreen-exit' : 'fullscreen'}
        style={styles.icon}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    top: 10,
    left: 10,
    height: 48,
    width: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    elevation: 30,
    zIndex: 30,
  },
  icon: {
    color: '#FFFFFF',
    fontSize: 28,
  },
});

VideoFullscreenButton.defaultProps = {
  testID: undefined,
};

VideoFullscreenButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  testID: PropTypes.string,
};

export default VideoFullscreenButton;
